module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"emptyText":"No sensors selected"},"it":{"emptyText":"Nessun sensore selezionato"}}')
  delete Component.options._Ctor
}
